/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

export default '53.0.3';
